import type { GetServerSideProps, NextPage } from 'next';
import { z } from 'zod';
import { modularPageWrapperSchema } from '../../components/ModularPageWrapper/schema';
import { getCachedEntry } from '../../utils/requests/contentstack/cachedRequests';
import { formatError, serverLogger } from '../../utils/loggers/server';
import { ModularPageWrapper } from '../../components/ModularPageWrapper';
import { getContentVariant, getContentstackEntryUid } from '../../utils/getContentVariant/getContentVariant';
import { jsonLdData } from './jsonLdData';
export type KidsPageProps = z.infer<typeof modularPageWrapperSchema>;
const KIDS_ENTRY_UIDS = {
  control: 'blt2a3605fd96c0dfea',
  q3Redesign: 'blt682f01dd68152049'
};
export const getServerSideProps: GetServerSideProps<KidsPageProps> = async ({
  req
}) => {
  const url = req.url || '/kids';
  try {
    const contentVariant = getContentVariant({
      url
    });
    const entryResponse = await getCachedEntry({
      contentType: 'modular_page',
      uid: getContentstackEntryUid({
        contentVariant,
        uids: KIDS_ENTRY_UIDS
      }),
      schema: modularPageWrapperSchema,
      logger: serverLogger
    });
    return {
      props: {
        seoData: entryResponse.data.seoData,
        modules: entryResponse.data.modules
      }
    };
  } catch (error: unknown) {
    serverLogger({
      level: 'error',
      team: 'client-onboarding',
      message: 'Required page data is undefined - Kids',
      context: {
        error: formatError(error),
        page: url,
        severity: 'critical'
      }
    });
    throw new Error('Required data not provided to render Kids page');
  }
};
const KidsPage: NextPage<KidsPageProps> = ({
  seoData,
  modules
}) => {
  return <ModularPageWrapper seoData={seoData} modules={modules} jsonLdData={jsonLdData} />;
};
export default KidsPage;